import { extend } from 'vee-validate';
import numeral from 'numeral';

extend('currency', {
    validate(value, { culture }: any) {
        return numeral.validate(value, culture);
    },
    params: ['culture']
});
